import { render } from "./AudioRating2.vue?vue&type=template&id=6da2b71a&ts=true"
import script from "./AudioRating2.vue?vue&type=script&lang=ts"
export * from "./AudioRating2.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Projects\\vdmar\\front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__